export default {
  props: {
    storeLoadKey: String,
    storeSaveKey: String,
    storeUpdateKey: String,
  },
  methods: {
    loadFromStore() {
      return this.$store.getters[this.storeLoadKey];
    },
  },
};
